// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WallArrow-module__main--vCR0b {
    position: relative;
    pointer-events: none;
    user-select: none;
}

.WallArrow-module__hidden--AaOXx {
    display: none;
}

.WallArrow-module__main--vCR0b img {
    position: absolute;
}

.WallArrow-module__main--vCR0b.WallArrow-module__leftWall--AnUZr img,
.WallArrow-module__main--vCR0b.WallArrow-module__rightWall--DxL8n.WallArrow-module__mirrored--iMl86 img {
    left: 0;
    right: unset;
    transform: rotate(180deg);
}

.WallArrow-module__main--vCR0b.WallArrow-module__rightWall--DxL8n img,
.WallArrow-module__main--vCR0b.WallArrow-module__leftWall--AnUZr.WallArrow-module__mirrored--iMl86 img {
    right: 0;
    left: unset;
    transform: rotate(0);
}

.WallArrow-module__main--vCR0b.WallArrow-module__backWall--WatT6 img,
.WallArrow-module__main--vCR0b.WallArrow-module__frontWall--Asl9U.WallArrow-module__mirrored--iMl86 img {
    top: 0;
    bottom: unset;
    transform: rotate(-90deg);
}

.WallArrow-module__main--vCR0b.WallArrow-module__frontWall--Asl9U img,
.WallArrow-module__main--vCR0b.WallArrow-module__backWall--WatT6.WallArrow-module__mirrored--iMl86 img {
    bottom: 0;
    top: unset;
    transform: rotate(90deg);
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/RoomSetup/WallArrow.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,OAAO;IACP,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,QAAQ;IACR,WAAW;IACX,oBAAoB;AACxB;;AAEA;;IAEI,MAAM;IACN,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;IAEI,SAAS;IACT,UAAU;IACV,wBAAwB;AAC5B","sourcesContent":[".main {\n    position: relative;\n    pointer-events: none;\n    user-select: none;\n}\n\n.hidden {\n    display: none;\n}\n\n.main img {\n    position: absolute;\n}\n\n.main.leftWall img,\n.main.rightWall.mirrored img {\n    left: 0;\n    right: unset;\n    transform: rotate(180deg);\n}\n\n.main.rightWall img,\n.main.leftWall.mirrored img {\n    right: 0;\n    left: unset;\n    transform: rotate(0);\n}\n\n.main.backWall img,\n.main.frontWall.mirrored img {\n    top: 0;\n    bottom: unset;\n    transform: rotate(-90deg);\n}\n\n.main.frontWall img,\n.main.backWall.mirrored img {\n    bottom: 0;\n    top: unset;\n    transform: rotate(90deg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `WallArrow-module__main--vCR0b`,
	"hidden": `WallArrow-module__hidden--AaOXx`,
	"leftWall": `WallArrow-module__leftWall--AnUZr`,
	"rightWall": `WallArrow-module__rightWall--DxL8n`,
	"mirrored": `WallArrow-module__mirrored--iMl86`,
	"backWall": `WallArrow-module__backWall--WatT6`,
	"frontWall": `WallArrow-module__frontWall--Asl9U`
};
export default ___CSS_LOADER_EXPORT___;
